import React, { useEffect, useState } from "react";
import Main from "../../../../layout/main/Main";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Modal, Spin } from "antd";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import {
	AntdButton,
	ButtonContainer,
	ImportInfoContainer,
	ImportResultContainer,
	Section,
	TitleContainer,
	UploadFile,
} from "./styles";
import moment from "moment";
import { BsUpload, BsCaretRight } from "react-icons/bs";
import { COLORS, Typo } from "../../../../layout/theme";
import ResultsTable from "../results-table/ResultsTable";
import {
	CheckOutlined,
	CloseCircleOutlined,
	InfoCircleFilled,
} from "@ant-design/icons";
import { CONSTANTS } from "../../../../../utils/constants";
import {
	confirm_imported_orders,
	download_imported_order_with_errors,
	import_orders,
} from "../../../../../api/endpoints/orders";
import Image from "../../../../common/image/Image";
import FakeProgress from "../../../../common/fake-progress-bar/FakeProgressBar";

export default function ImportOrders({ clientId }) {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const uri = searchParams.get("uri");
	const [errors, setErrors] = useState(null);
	const [isLoading, setIsLoading] = useState([false, false, false, false]);
	const [importResponse, setImportResponse] = useState(null);
	const [failedOrders, setFailedOrders] = useState([]);
	const [showUploadFileModal, setShowUploadFileModal] = useState(false);
	const [failedRecordsToExport, setFailedRecordsToExport] = useState([]);
	const [isConfirming, setIsConfirming] = useState(false);
	const [historyId, setHistoryId] = useState(null);

	const handleChange = async (e, type) => {
		if (type === "import") {
			setIsLoading([false, true, false, false]);
			setFailedOrders([]);
			setFailedRecordsToExport([]);
			try {
				const formData = new FormData();
				formData.append(
					"file",
					e.fileList[e.fileList.length - 1].originFileObj
				);
				formData.append(
					"data",
					JSON.stringify({
						clientId: clientId,
					})
				);
				const res = await import_orders(formData);
				setImportResponse(res);
				setErrors(res?.errors);
				if (res?.errors?.length > 0) {
					openNotificationWithIcon(
						TYPE.ERROR,
						"Las ordenes que intenta subir no se cargaron",
						"Las ordenes que intenta subir tienen problemas, reviselos y subalos de nuevo"
					);
				}
			} catch (error) {
				const errors = Object.entries(error?.response?.data?.errors);
				openNotificationWithIcon(
					TYPE.ERROR,
					errors?.map((e) => `${e[1]} `).concat() ||
						"Las Ordenes deben subirse en formato excel. Verifique que este bien su archivo"
				);
			} finally {
				setIsLoading([false, false, false, false]);
				setShowUploadFileModal(false);
			}
		}

		if (type === "confirmImport") {
			setIsLoading([false, false, true, false]);
			setIsConfirming(true);
			try {
				const postData = {
					groupedOrders: importResponse?.groupedPreview,
					clientId: clientId,
				};
				const res = await confirm_imported_orders(postData);
				setHistoryId(res?.historyId);
				if (res?.success) {
					setImportResponse(null);
					openNotificationWithIcon(
						TYPE.SUCCESS,
						"Importación exitosa",
						"Las órdenes fueron ingresadas correctamente"
					);
				} else {
					setFailedOrders(res.failedOrders || []);
					setFailedRecordsToExport(res.failedRecordsToExport || []);
					if (res?.failedRecordsToExport?.length > 0) {
						openNotificationWithIcon(
							TYPE.WARNING,
							"No se pudieron crear algunas órdenes",
							`No se pudieron importar ${res.failedRecordsToExport.length} registros.`
						);
					}
				}
			} catch (error) {
				console.log(error);
				const errors = Object.entries(error?.response?.data?.errors);
				openNotificationWithIcon(
					TYPE.ERROR,
					errors?.map((e) => `${e[1]} `).concat() ||
						"Las Ordenes deben subirse en formato excel. Verifique su archivo"
				);
			} finally {
				setIsLoading([false, false, false, false]);
				setIsConfirming(false);
			}
		}

		if (type === "cancelImport") {
			setImportResponse(null);
			setFailedOrders([]);
			setFailedRecordsToExport([]);
		}
	};

	const handleUploadModalOk = () => {
		setShowUploadFileModal(false);
	};

	const handleUploadModalCancel = () => {
		setShowUploadFileModal(false);
	};

	const handleDownloadFile = async () => {
		setIsLoading([false, false, true, false]);
		try {
			const _ordersWithErrors = failedRecordsToExport;

			const res = await download_imported_order_with_errors({
				ordersWithErrors: _ordersWithErrors,
			});

			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;
			const _fileName =
				"Ordenes_Importadas_con_Error_" +
				moment().format("DD-MM-YYYY") +
				".xlsx";
			link.setAttribute("download", _fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading([false, false, false, false]);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Importar</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<ButtonContainer>
					<AntdButton
						loading={isLoading[1] || isLoading[2]}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							width: "230px",
						}}
						onClick={() => setShowUploadFileModal(true)}
					>
						{/* <UploadFile
							multiple={false}
							showUploadList={false}
							beforeUpload={() => false}
							action={null}
							onChange={(e) => handleChange(e, "import")}
						> */}
						<BsUpload
							style={{ position: "relative", top: "0.8px", left: "-5px" }}
						/>
						<Typo type="white" level={6}>
							Subir archivo con ordenes
						</Typo>
						{/* </UploadFile> */}
					</AntdButton>
					<Modal
						title={
							<TitleContainer>
								<Typo
									type="primary"
									level={6}
									style={{ cursor: "pointer", userSelect: "none" }}
								>
									Importar datos <InfoCircleFilled />
								</Typo>
								<Typo level={7}>Información de archivo de subida</Typo>
								<Typo level={7}>Extensiones admitidas: .xlsx, .xls, .csv</Typo>
							</TitleContainer>
						}
						open={showUploadFileModal}
						onOk={handleUploadModalOk}
						onCancel={handleUploadModalCancel}
						centered={false}
						footer={null}
						destroyOnClose={true}
					>
						<UploadFile
							multiple={false}
							showUploadList={false}
							beforeUpload={() => false}
							action={null}
							onChange={(e) => handleChange(e, "import")}
							disabled={isLoading[1] || isLoading[2]}
						>
							{isLoading[1] || isLoading[2] ? (
								<Spin size="default" />
							) : (
								<Section>
									<Image src={CONSTANTS.URL_SHEET_ICON} width="80px" />
									<Typo level={7}>
										Haga click para elegir el archivo desde el explorador
									</Typo>
									<Typo level={7}>
										También puede arrastrarlo y soltarlo en este espacio
									</Typo>
								</Section>
							)}
						</UploadFile>
					</Modal>
				</ButtonContainer>

				<ImportResultContainer>
					{!importResponse && (
						<ImportInfoContainer>
							<Typo type="primary" level={5}>
								Formato requerido del archivo Excel
							</Typo>
							<Typo type="grey" level={6}>
								Extensión admitida: <b>.xlsx</b>, <b>.xls</b>, <b>.csv</b>
							</Typo>
							<Typo type="grey" level={6}>
								Las columnas deben estar en el siguiente orden:
							</Typo>
							<ul style={{ paddingLeft: "18px" }}>
								<li>Nombre de la oportunidad o numero de orden externo</li>
								<li>Nombre de la cuenta</li>
								<li>CUIT</li>
								<li>Nombre del producto</li>
								<li>EAN</li>
								<li>Cantidad</li>
								<li>Descuento por Cantidad (PVP Final)</li>
								<li>Nombre Droguería</li>
								<li>Código Cliente en Droguería</li>
								<li>Fecha de creación</li>
							</ul>
						</ImportInfoContainer>
					)}
					{importResponse &&
						importResponse?.groupedPreview?.length > 0 &&
						failedOrders.length === 0 &&
						failedRecordsToExport.length === 0 && (
							<ButtonContainer>
								<Typo type="primary" level={6}>
									Resultado importación
								</Typo>
								<AntdButton
									onClick={(e) => handleChange(e, "confirmImport")}
									loading={isLoading[2]}
									success={true}
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										width: "220px",
									}}
								>
									<CheckOutlined
										style={{ position: "relative", top: "0.8px", left: "2px" }}
									/>{" "}
									<Typo type="white" level={6}>
										Confirmar importación
									</Typo>
								</AntdButton>
								<AntdButton
									onClick={(e) => handleChange(e, "cancelImport")}
									loading={isLoading[2]}
									cancel={true}
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										width: "220px",
									}}
								>
									<CloseCircleOutlined
										style={{ position: "relative", top: "0.8px", left: "2px" }}
									/>{" "}
									<Typo type="white" level={6}>
										Cancelar importación
									</Typo>
								</AntdButton>
							</ButtonContainer>
						)}
					{!importResponse &&
						(failedOrders.length > 0 || failedRecordsToExport.length > 0) && (
							<ButtonContainer>
								<AntdButton
									onClick={(e) => handleChange(e, "cancelImport")}
									loading={isLoading[2]}
									cancel={true}
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										width: "220px",
									}}
								>
									<CloseCircleOutlined
										style={{ position: "relative", top: "0.8px", left: "2px" }}
									/>{" "}
									<Typo type="white" level={6}>
										Reiniciar
									</Typo>
								</AntdButton>
							</ButtonContainer>
						)}
					{importResponse && importResponse?.groupedPreview?.length > 0 && (
						<ResultsTable data={importResponse?.groupedPreview} />
					)}
					{failedOrders.length > 0 && (
						<div style={{ marginTop: "20px", color: "red" }}>
							<Typo type="danger" level={5}>
								Orden enviada salvo estos registros por los siguientes errores:
							</Typo>
							<ul>
								{failedOrders.map((f, i) => (
									<li key={i}>
										<b>{f.posName || f.posCuit}</b> ({f.distributorName}):{" "}
										{f.reason}
									</li>
								))}
							</ul>
						</div>
					)}
					{failedRecordsToExport.length > 0 && failedOrders.length === 0 && (
						<div style={{ marginTop: "20px", color: "red" }}>
							<Typo type="danger" level={5}>
								Productos sin enviar:
							</Typo>
							<ul>
								{failedRecordsToExport.map((f, i) => (
									<li key={i}>
										<b>{f.posName || f.posCuit}</b> ({f.distributorName}):{" "}
										{f.productEan} - {f.productName} | Cantidad:{" "}
										{f.productQuantity} | Descuento: {f.productDiscount} %
									</li>
								))}
							</ul>
						</div>
					)}
					{failedRecordsToExport.length > 0 &&
						(isLoading[1] || isLoading[2] ? (
							<Spin size="small" />
						) : (
							<>
								<AntdButton
									onClick={() =>
										historyId &&
										navigate(`/admin/importOrdersHistory/${historyId}`)
									}
									loading={isLoading[2]}
									cancel={true}
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										width: "240px",
									}}
								>
									<BsCaretRight
										size={18}
										color={COLORS.White}
										style={{
											position: "relative",
											top: "0.8px",
											left: "-5px",
										}}
									/>{" "}
									<Typo type="white" level={6}>
										Ver registros sin enviar
									</Typo>
								</AntdButton>
								{/* <CustomAntdTooltip
									placement="top"
									width="105px"
									tooltipContent={[
										{
											body: "Exportar datos con error",
										},
									]}
								>
									<AntdButton
										onClick={handleDownloadFile}
										loading={isLoading[2]}
										cancel={true}
										style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											width: "240px",
										}}
									>
										<BsDownload
											size={18}
											color={COLORS.White}
											style={{
												position: "relative",
												top: "0.8px",
												left: "-5px",
											}}
										/>{" "}
										<Typo type="white" level={6}>
											Descargar registros con error
										</Typo>
									</AntdButton>
								</CustomAntdTooltip> */}
							</>
						))}
					<Modal
						open={isConfirming}
						footer={null}
						closable={false}
						centered
						destroyOnClose
					>
						<FakeProgress
							isLoading={isConfirming}
							title={"Importando ordenes"}
						/>
					</Modal>
				</ImportResultContainer>
			</Main.Body>
		</Main>
	);
}
